<template>
  <div
    class="fixed w-full h-full top-0 left-0 bg-white pointer-events-none z-10 opacity-0"
    ref="overlay"
  ></div>

  <div
    class="flex items-center justify-center absolute flex-col gap-3 z-10 h-10 p-2 pointer-events-none"
    ref="performanceContainer"
  >
    <div
      class="absolute text-lg title-color opacity-0 -translate-y-[200%]"
      ref="title"
    >
      Votre Performance Rapidoo
    </div>
    <div class="title-color w-[4ch] text-center">{{ displayedPercent }}%</div>

    <div
      class="w-3/4 bg-gray-100 opacity-0 rounded-full overflow-hidden h-4 absolute translate-y-[300%]"
      ref="progressBar"
    >
      <div
        class="bg-primary h-4 rounded-full"
        ref="filled"
        :style="{ width: displayedPercent + '%' }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import gsap from 'gsap'
import { onMounted, ref } from 'vue'

const performanceContainer = ref(null)
const overlay = ref(null)
const filled = ref(null)
const progressBar = ref(null)
const title = ref(null)
const displayedPercent = ref(0)

const limit = 1 // % maximum à atteindre

function makeProgressAnimation() {
  gsap.to(displayedPercent, {
    value: limit,
    duration: 2,
    ease: 'power1.in',
    onUpdate: () => {
      displayedPercent.value = Math.round(displayedPercent.value)
    },
  })

  if (window.onceShowedProgress) return

  gsap.from(overlay.value, {
    opacity: 1,
    duration: 1,
    delay: 3,
    onComplete: () => {
      overlay.value.style.display = 'none'
    },
  })
  gsap.from(progressBar.value, {
    opacity: 1,
    delay: 3,
  })
  gsap.from(title.value, {
    opacity: 1,
    delay: 3,
  })
  gsap.from(performanceContainer.value, {
    width: '100vw',
    height: '100vh',
    top: '0vh',
    left: '0vw',
    duration: 1,
    delay: 3.5,
    ease: 'power2.inOut',
    fontSize: '3rem',
  })
  window.onceShowedProgress = true
}

onMounted(() => {
  makeProgressAnimation()
})
</script>

<style scoped>
.bg-blue-500 {
  transition: width 0.1s linear;
}
</style>
